import { render, staticRenderFns } from "./InvestFinanceRemindList.vue?vue&type=template&id=08c2366a"
import script from "./InvestFinanceRemindList.vue?vue&type=script&lang=ts"
export * from "./InvestFinanceRemindList.vue?vue&type=script&lang=ts"
import style0 from "./InvestFinanceRemindList.vue?vue&type=style&index=0&id=08c2366a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports